import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* createCodeBxgy({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.codes.create.bxgy, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.createCodeBxgyDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createCodeBxgyFailed,
      handledErrors,
      endpoint: api.codes.create.bxgy.url
    });
  }
}

export const createCodeBxgySaga = takeEvery(types.CREATE_CODE_BXGY_REQUEST, createCodeBxgy);